import axios from "axios";
import { api_url } from "../conf/conf";

export async function getOneCApiKeys() {
  const response = await axios.get(`${api_url}/one-c-api-keys`);
  return response.data;
}

export async function createOneCApiKey(payload) {
  const response = await axios.post(`${api_url}/one-c-api-keys`, payload);
  return response.data;
}

export async function updateOneCApiKey(id, payload) {
  const response = await axios.patch(`${api_url}/one-c-api-keys/${id}`, payload);
  return response.data;
}
